import React from "react";
import { PaymentModalStyle } from "./PaymentModalStyle.style";
import PricingPlan from "./PricingPlan";

interface PricingModalProps {
  isOpen: boolean;
  onClose: () => void;
  next: (id: string, type: string, duration: string, currency: string) => void;
  showmenu?: boolean;
  currentPlan?: string;
  currentPriceId?: string;
  selectedCurrency?: string;
  banner?: React.ReactNode;
  actionsDisabled?: boolean;
}

const PricingModal: React.FC<PricingModalProps> = ({
  isOpen,
  onClose,
  next,
  showmenu,
  currentPlan,
  currentPriceId,
  selectedCurrency,
  banner,
  actionsDisabled,
}) => {
  
  // useEffect(()=>{
  //     console.log(selectedCurrency,'selectedCurrency')
  // },[selectedCurrency])

  return (
    // <PricingModalStyle>
    <PaymentModalStyle
      footer={false}
      className="pricingModal-component"
      centered
      open={isOpen}
    >
      <div className="login-modal">
        {showmenu && (
          <div className="login-heading-container">
            <img alt="close.svg" src="./static/close.svg" onClick={onClose} />
          </div>
        )}
        {banner}
        <PricingPlan
          selectedCurrency={
            selectedCurrency !== undefined ? selectedCurrency : ""
          }
          blob={false}
          next={next}
          currentPlan={currentPlan}
          currentPriceId={currentPriceId}
          actionsDisabled={actionsDisabled}
        />
      </div>
    </PaymentModalStyle>
    // </LoginModalStyle>
  );
};

export default PricingModal;
